<div class="container">
  <div class="row mt-5">
    <div class="col-md-12 text-center" style="font-size:1.4em; font-weight:bold; text-decoration:underline; color:red">
      Online Claims Filing Has Ended
    </div>
  </div>
</div>







<!--<div class="container">
  <div class="row mt-5">
    <div class="col-md-12 text-center" style="font-size:1.4em; font-weight:bold; text-decoration:underline">
      Colombo v. Nationstar Mortgage LLC CLAIM FORM
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      To submit a claim, you will need both your <b>Claim ID</b> and <b>Unique ID,</b> which can be found on the Email or Postcard Notice you received.<br /><br />


      If you did not receive a Notice or cannot locate your IDs, please contact us to request a copy by <b>Email: </b> <a href="mailto:info@FloridaNationstarLawsuit.com">info@FloridaNationstarLawsuit.com</a> or
      by<br /> <b>Toll-Free Phone:</b> 1-866-963-9973.<br /><br />


      <b>Claim forms must be submitted online by 12:00 a.m. (midnight) Eastern Standard Time on August 15, 2026.</b><br /><br />


      If you do not provide the correct information, your claim(s) may be denied and you will not get a payment.
    </div>
  </div>
  <div class="containerLogin login-container">
    <form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">
      <div class="row mt-3">
        <div class="col-md-3"></div>
        <div class="col-md-6 login-form-1 mb-4">
          <h3 class="misc-titles text-center">Login</h3>
          <p class="text-center">
            To register, please enter the Claim ID and Unique ID provided to you on your Notice.
          </p>
          <div class="form-group">
            <label class="titleBold" for="claimId">Claim ID: <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="claimId" trim="blur" autocomplete="off"
                   [ngClass]="{ 'is-invalid': submitted && f.claimId.errors }" />
            <div *ngIf="submitted && f.claimId.errors" class="invalid-feedback">
              <div *ngIf="f.claimId.errors.required">This field is required</div>
              <div *ngIf="f.claimId.errors.minlength">This field must be at least 10 digits</div>
              <div *ngIf="f.claimId.errors.maxlength">
                This field must not be at greater 10 digits
              </div>
              <div *ngIf="f.claimId.errors.pattern">This field accepts only numerical digits 0-9</div>
            </div>
          </div>
          <div class="form-group">
            <label class="titleBold" for="uniqueId">Unique ID: <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="uniqueId" trim="blur" autocomplete="off"
                   [ngClass]="{ 'is-invalid': submitted && f.uniqueId.errors }" />
            <div *ngIf="submitted && f.uniqueId.errors" class="invalid-feedback">
              <div *ngIf="f.uniqueId.errors.required">This field is required</div>
              <div *ngIf="f.uniqueId.errors.minlength">This field must be at least 8 digits/characters</div>
              <div *ngIf="f.uniqueId.errors.maxlength">
                This field must not be at greater 8 digits/characters
              </div>
              <div *ngIf="f.uniqueId.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-center">
              <div class="form-group">
                <button class="btn btn-primary" id="login" [disabled]="clicked">LOGIN</button>
              </div>
            </div>
          </div>

          <div class="row mt-3" *ngIf="showDivSubmittalErrorMessage === true">
            <div class="col-md-12" style="border:1px solid #bebaba; font-weight:400; color:red; padding-top:1%; padding-bottom:1%">
              The Claim ID and/or Unique ID you entered do not match our database. Please contact us to request a copy of your Claim ID & Unique ID by
              Email: <a href="mailto:info@FlordiaNationstarLawsuit.com">info@FlordiaNationstarLawsuit.com</a> or by Toll-Free Phone: <br />1-866-963-9973.
              You May also download a copy of the Claim Form <a href="https://floridanationstarlawsuit.com/File-a-Claim">here.</a>
            </div>
          </div>
        </div>
      </div>
    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>-->
